import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../categories/category.css";
import * as movieActions from "../../redux/actions/movieActions";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import * as detailActions from "../../redux/actions/detailsActions";

import "../categories/category.css";
class Categorized extends Component {
  state = { pageList: [1, 2, 3, 4, 5, 6, 7, 8, 9], count: 2 };

  checkCount() {
    var timeleft = 2;
    var downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
      } else {
        timeleft -= 1;
        this.setState({ count: this.state.count - 1 });
      }
    }, 1000);
  }

  movieDetail(movieId) {
    localStorage.setItem("id", movieId);
    this.props.actions.getChoosenMovie(parseInt(localStorage.getItem("id")));
  }
  pageBtnActive() {
    const btn_list = document.querySelectorAll(".page_btn");

    if (localStorage.getItem("page2")) {
        let pageİndex = localStorage.getItem("page2");
        btn_list[pageİndex - 1].style.background = "#393e46";
        btn_list[pageİndex - 1].style.color = "whitesmoke";
      }
    
  }
  pageClick(page) {
    const loader = document.querySelector(".lds-dual-ring");
    const content = document.querySelector(".content");
    const href = window.location.pathname.replace("/category/", "");
    const btn_list = document.querySelectorAll(".page_btn");

    localStorage.setItem("page2",page)
    btn_list.forEach((btn) => {
      btn.style.background = "whitesmoke";
      btn.style.color = "black";
    });
    btn_list[page - 1].style.background = "#393e46";
    btn_list[page - 1].style.color = "whitesmoke";

    loader.style.display = "block";
    content.style.opacity = "0";
    window.scroll(0, 0);

    setTimeout(() => {
      content.style.opacity = "1";
      loader.style.display = "none";
    }, 2000);
    setTimeout(() => {
      this.props.actions.getCategorizedMovies(parseInt(href), page);
    }, 300);
  }
  componentDidMount() {
    const content = document.querySelector(".content");
    const loader = document.querySelector(".lds-dual-ring");
    const href = window.location.pathname.replace("/category/", "");
    const btn_list = document.querySelectorAll(".page_btn");

    
    btn_list.forEach(btn =>{
        btn.style.opacity="0";
    })
    this.checkCount();
    
    content.style.opacity = "0";
    if (localStorage.getItem("page2")) {
      this.props.actions.getCategorizedMovies(
        parseInt(href),
        localStorage.getItem("page2")
      );
    } else {
      this.props.actions.getCategorizedMovies(parseInt(href), 1);
    }

   

    loader.style.display = "block";
    loader.style.opacity = "1";

    setTimeout(() => {
      loader.style.display = "none";
      content.style.opacity = "1";
      btn_list.forEach(btn =>{
        btn.style.opacity="1";
    })
      this.pageBtnActive();
    }, 3000);
  }

  render() {
    return (
      <Container className="cont" data-anime="left">
        <h3 className="text-light title w-75">
          {this.props.currentCategory} category movies.
        </h3>
        <div
          className="lds-dual-ring mt-5"
          style={{
            display: "none",
            marginBottom: "300px",
          }}
        ></div>
        <Content className="content">
          {this.props.categorizedMovies.map((movie, key) => (
            <Link
              key={key}
              onClick={() => this.movieDetail(movie.id)}
              to={`/movie/${movie.id}`}
              onContextMenu={() => this.movieDetail(movie.id)}
            >
              <Wrap key={movie.title}>
                <LazyLoadImage
                  alt={movie.title}
                  src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                  key={movie.poster_path}
                />
              </Wrap>
            </Link>
          ))}
        </Content>
        <div className="row page_btn_part">
              {this.state.pageList.map((page) => (
                <button
                  onClick={() => this.pageClick(page)}
                  key={page}
                  className="mx-2 page_btn">
                  {page}
                </button>
              ))}
            </div>
      </Container>
    );
  }
}

const Container = styled.div`
  padding: 0 0 26px;
  justify-content: center;
  text-align: center;
  transition: 0.4s ease-in-out;
  margin-top: 100px;
  background: #090b13;
`;

const Content = styled.div`
  display: grid;
  grid-gap: 25px;
  gap: 25px;
  margin: auto;
  margin-top: 1%;
  width: 90%;
  transition: 0.4s ease-in-out;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 500px) {
    width: 98%;
  }
`;

const Wrap = styled.div`
  padding-top: 140.25%;
  border-radius: 1.1rem;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  border: 3px solid rgba(249, 249, 249, 0.1);
  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: absolute;
    transition: opacity 500ms ease-in-out 0.1s;
    width: 100%;
    z-index: 0;
    top: 0;
  }
  &:hover {
    box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
      rgb(0 0 0 / 72%) 0px 30px 22px -10px;
    transform: scale(1.05);
    border-color: rgba(249, 249, 249, 0.8);
  }
`;

function mapStateToProps(state) {
  return {
    currentCategory: state.changeCategoryReducer,
    categorizedMovies: state.categorizedMoviesReducer,
    choosenMovie: state.detailReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getCategorizedMovies: bindActionCreators(
        movieActions.getCategorizedMovies,
        dispatch
      ),

      getChoosenMovie: bindActionCreators(detailActions.getMovie, dispatch)
      
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Categorized);
